export default __webpack_public_path__ + "static/media/jasmine_and_ian-249_tn.511f82d4.jpg";